export default __webpack_public_path__ + "static/media/live_chat.f668c854.svg";